module.exports = __webpack_public_path__ + "static/media/TextEnrichesBadOptimized.197cf098.jp2";